module.exports = __webpack_public_path__ + "static/media/pic-1.8da125c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_imagerecognition/pic-1.png
// module id = 540
// module chunks = 0